import { render, staticRenderFns } from "./NotiCardList.vue?vue&type=template&id=735f1032&"
import script from "./NotiCardList.vue?vue&type=script&lang=js&"
export * from "./NotiCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports